import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { Component, Inject, ViewChild } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogModule, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { MatStep, MatStepper, MatStepperModule } from '@angular/material/stepper';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { Countertop } from '../../../models/cutting/countertop';
import { CuttingCustomGrooveSchema } from '../../../models/cutting/cutting-custom-groove-schema.model';
import { CuttingPanelBaseSlot } from '../../../models/cutting/cutting-panel-base-slot.model';
import { CuttingPanelSlot } from '../../../models/cutting/cutting-panel-slot.model';
import { CountertopSchemaComponent } from '../../countertop-schema/countertop-schema.component';
import { SlotSelectComponent } from '../../slot-select/slot-select.component';

export interface SlotWizardDialogData {
  countertop: Countertop;
  slots: CuttingPanelBaseSlot[];
  postCustomSlotsData?: (slot: CuttingPanelSlot) => Observable<number>;
  deleteCustomSlot?: (id: number) => Observable<void>;
  fullPanelThickness?: number;
  customSlotSchemas?: CuttingCustomGrooveSchema[];
}

export interface SlotWizardDialogResult {
  sideNumbers: number[];
  slot: CuttingPanelBaseSlot;
}

@Component({
  templateUrl: 'slot-wizard-dialog.component.html',
  styles: [
    `
      :host ::ng-deep .mat-horizontal-content-container {
        display: none;
      }
    `,
  ],
  standalone: true,
  imports: [
    MatIconModule,
    MatLegacyButtonModule,
    MatDividerModule,
    CountertopSchemaComponent,
    MatStepperModule,
    MatLegacyDialogModule,
    SlotSelectComponent,
    NgClass,
    NgIf,
    AsyncPipe,
  ],
})
export class SlotWizardDialogComponent {
  selectedSlot: CuttingPanelBaseSlot;
  sideNumbers: Set<number> = new Set();

  @ViewChild(CountertopSchemaComponent, { static: true }) schema: CountertopSchemaComponent;
  @ViewChild(MatStepper, { static: true }) stepper: MatStepper;
  @ViewChild('sideSelectStep', { static: true }) sideSelectStep: MatStep;

  constructor(
    public dialogRef: MatLegacyDialogRef<SlotWizardDialogComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: SlotWizardDialogData
  ) {}

  ngAfterViewInit(): void {
    this.render();
  }

  render(): void {
    this.schema?.render(this.data.countertop, 'schema', {
      sideSelectors: true,
      highlightedSides: _.fromPairs(Array.from(this.sideNumbers).map(key => [key, 'red'])),
    });
  }

  sideSelected(sideNumber: number): void {
    this.sideNumbers.has(+sideNumber) ? this.sideNumbers.delete(+sideNumber) : this.sideNumbers.add(+sideNumber);

    this.render();
  }

  saveAndClose(): void {
    this.dialogRef.close({
      slot: this.selectedSlot,
      sideNumbers: Array.from(this.sideNumbers),
    } as SlotWizardDialogResult);
  }

  goToEdgeBandingSelect(): void {
    this.sideSelectStep.completed = true;
    this.stepper.next();
  }

  selectionChanged(items: CuttingPanelBaseSlot[]) {
    this.selectedSlot = items?.[0];
  }
}
